import { useEffect, useRef } from "react";

import "./AboutMe.css";

import SectionHeader from "../_components/section-header/SectionHeader";
import SmallCaption from "../_components/small-caption/SmallCaption";
import Link from "../_components/link/Link";

import { HAND_PUZZLE_1, HAND_PUZZLE_2, SPACE, SPACE_MOBILE } from "../_media/assets";

import createAnimation from "../_utils/createAnimation";
import FAQ from "../faq/FAQ";
import { BOOK_SESSION } from "../_utils/links";

const AboutMe = () => {
  const img = useRef(null);
  const header = useRef(null);
  const text = useRef(null);
  const quote = useRef(null);
  const specialties = useRef(null);
  const refs = [img, header, text, quote, specialties];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => refs.forEach((ref) => createAnimation(ref)), []);

  return (
    <main className="AboutMe">
      <div className="AboutMe-img-wrapper" ref={img}>
        <img src={window.innerWidth >= 900 ? SPACE : SPACE_MOBILE} alt="" />
      </div>
      <section className="AboutMe-header" ref={header}>
        <SmallCaption text="Meet the Licenced Professional" />
        <SectionHeader text="Hello, my name is Miriam!" />
      </section>
      <section className="AboutMe-about" ref={text}>
        <aside className="AboutMe-about-img">
          <img src={HAND_PUZZLE_1} alt="" />
        </aside>
        <article className="AboutMe-about-text">
          Therapy can be a great way to develop strategies for dealing with
          distressing thoughts or emotions. As you work on changing your
          unhealthy thinking patterns and feelings, you may also find that your
          behavior starts to change. Therapy is more than just getting rid of
          negative emotions - it's about developing the flexibility to change
          our behavior based on what we perceive will benefit our overall
          well-being.
          <br />
          <br />
          <b>I’m the door, but you are the key to your transformation.</b> I
          want my clients to know they are never inferior to me as their
          therapist. My therapeutic approach is driven by my belief in my
          client's innate potential for self-actualization. I use an integrative
          process that pulls from various modalities to provide clients with a
          more well-rounded therapy experience. Much of your transformation
          through therapy will depend on your willingness to hone in on the
          self-concept.
          <br />
          <br />
          <b>Don’t let anything keep you from living your best life.</b>{" "}
          Unhealthy schemas are frequently formed in reaction to childhood
          events or trauma with unmet emotional needs. Are you ready for change
          and healing? Contact me today to begin your journey to wholeness.
          Because I personalize each session to each client's specific needs,
          everyone can live a better and more fulfilling life.
        </article>
      </section>
      <blockquote className="AboutMe-quote" ref={quote}>
        “I offer sessions designed to help you shift subconscious imprinting,
        uncover your authentic self, align with your purpose, and live in the
        present moment.”
      </blockquote>
      <section className="AboutMe-specialties" ref={specialties}>
        <div className="AboutMe-specialties-wrapper">
          <SmallCaption text="Journey Within" />
          <SectionHeader text="Therapy Specialty" />
          <ul className="AboutMe-specialties-list">
            <li>Depression</li>
            <li>Grief and Loss</li>
            <li>Life Transitions</li>
            <li>Personal Growth and Self-Esteem</li>
            <li>Relationship challenges (family, friends, co-workers)</li>
          </ul>
          <Link primary ariaLabel="Click to book a free session" link={BOOK_SESSION}>
            Book a free session
          </Link>
        </div>
        <aside className="AboutMe-specialties-img">
          <img src={HAND_PUZZLE_2} alt="" />
        </aside>
      </section>
      <FAQ />
    </main>
  );
};

export default AboutMe;
